import axios from 'axios'
import { AuthModel, ResendOTPModel, UserModel } from './_models'
import { APIResponse } from '../../../pages/account/Account.types'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_DETAIL = `${API_URL}/user/me`
export const USER_NOTIFICATION = `${API_URL}/user/me/notification-token`
export const LOGIN_URL = `${API_URL}/auth/login`
export const REQUEST_PASSWORD_URL = `${API_URL}/auth/admin/reset-password`

export const VERIFY_OTP = `${API_URL}/auth/verify-otp`
export const RESEND_OTP = `${API_URL}/auth/resend-otp/email`

// Server should return AuthModel
export function login(email: string, password: string, device_code?: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
    device_code,
    role: 'Admin',
    portal: 'admin',
  })
}

// Admin accounts are created by a super admin from Users → Company staff
// (POST /admin/user with role=Admin). Self-registration is deliberately gone —
// the endpoint behind it was unauthenticated.

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function userNotification(token: string) {
  return axios.post<APIResponse>(USER_NOTIFICATION, {
    token,
  })
}

export function getUser() {
  return axios.get<{ result: UserModel }>(GET_USER_DETAIL)
}

export function authVerifyOtpAPI(body: any) {
  return axios.post<AuthModel>(VERIFY_OTP, body)
}

export function authResendOtpAPI(body: any) {
  return axios.post<ResendOTPModel>(RESEND_OTP, body)
}
